import React from "react";
import { ReactComponent as LogoFull } from "../../assets/icons/logo_full.svg";

const footerLinks = [
  { label: "Highlights", href: "#brands" },
  { label: "How it flows", href: "#journey" },
  { label: "Plans", href: "#batches" },
  { label: "Contact", href: "#contact" },
];

const socialLinks = [
  { label: "Instagram", href: "https://www.instagram.com/ukuleleseekho" },
  { label: "Youtube", href: "https://www.youtube.com/channel/UCkda8gvHy2LlbwceDh5wTjw" },
];

const Footer: React.FC = () => {
  return (
    <footer className="relative overflow-hidden bg-accentNavy py-14 text-white/80 sm:py-16">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(255,255,255,0.08),_transparent_65%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,_rgba(255,255,255,0.05),_transparent_70%)]" />

      <div className="relative mx-auto flex max-w-6xl flex-col gap-10 px-6 sm:gap-12">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div className="max-w-sm space-y-4">
            <div className="flex items-center gap-3">
              
              <span className="text-xl font-semibold text-white">
                Ukulele Seekho
              </span>
            </div>
            <p className="text-sm leading-relaxed text-white/70">
              A joyful home for curious players to build tone, timing, and stage confidence
              with guidance that keeps practice inspiring.
            </p>
            {/* App badge — Headspace / Duolingo pattern: sits right under the brand blurb */}
            <div className="pt-1">
              <a
                href="https://play.google.com/store/apps/details?id=co.martin.swjtr"
                target="_blank"
                rel="noreferrer"
                aria-label="Get it on Google Play"
                className="inline-block transition-all duration-200 hover:-translate-y-0.5 hover:opacity-90"
              >
                <img
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                  alt="Get it on Google Play"
                  className="h-12 w-auto"
                />
              </a>
            </div>
          </div>
          <div className="flex items-center justify-center">
            <a href="/" aria-label="Back to Home">
              <LogoFull className="h-52 w-52" />
            </a>
        </div>
          <div className="grid gap-8 text-sm sm:grid-cols-2">
            <nav className="space-y-3">
              <p className="text-xs font-semibold uppercase tracking-[0.28em] text-white/50">
                Explore
              </p>
              <ul className="space-y-2">
                {footerLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="inline-flex items-center gap-2 text-sm font-medium text-white/80 transition-transform hover:translate-x-1 hover:text-white"
                    >
                      <span>→</span>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
            
            <div className="space-y-3">
              <p className="text-xs font-semibold uppercase tracking-[0.28em] text-white/50">
                Follow
              </p>
              <ul className="space-y-2">
                {socialLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-2 text-sm font-medium text-white/80 transition-transform hover:-translate-y-[2px] hover:text-white"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-start gap-3 border-t border-white/20 pt-6 text-xs text-white/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Ukulele Seekho. All rights reserved.</p>
          <div className="flex flex-wrap gap-4">
            <a href="#privacy" className="hover:text-white">
              Privacy
            </a>
            <a href="#terms" className="hover:text-white">
              Terms
            </a>
            <a href="mailto:admin@ukuleleseekho.com" className="hover:text-white">
              admin@ukuleleseekho.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

